import { Link } from "wouter";
import { Instagram } from "lucide-react";

import { MUM_HUB_WEB_ENABLED } from "@/lib/mum-hub/flag";

export default function Footer() {
  return (
    <footer className="bg-charcoal dark:bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <img src="/logo-light.svg" alt="Capsule Chic Hub by Maria Pastor" width={600} height={130} className="h-16 mb-4" />
            <p className="text-gray-300 mb-6 max-w-md">
              Curating the world's finest fashion and lifestyle pieces for the discerning individual. 
              Quality over quantity, always.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/capsulechichub/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-soft-blush transition-colors duration-200" 
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link href="/shop" className="text-gray-300 hover:text-soft-blush transition-colors duration-200">Shop</Link></li>
              <li><Link href="/about" className="text-gray-300 hover:text-soft-blush transition-colors duration-200">About</Link></li>
              <li><Link href="/how-i-choose" className="text-gray-300 hover:text-soft-blush transition-colors duration-200">How I Choose</Link></li>
              {/* MAR-219. Static flag only, same as the header, so the footer
                  never grows after first paint. */}
              {MUM_HUB_WEB_ENABLED ? (
                <li><Link href="/mum-hub" className="text-gray-300 hover:text-soft-blush transition-colors duration-200">Mum Hub</Link></li>
              ) : null}
              <li><Link href="/contact" className="text-gray-300 hover:text-soft-blush transition-colors duration-200">Contact</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><Link href="/privacy" className="text-gray-300 hover:text-soft-blush transition-colors duration-200">Privacy Policy</Link></li>
              <li><Link href="/terms-and-conditions" className="text-gray-300 hover:text-soft-blush transition-colors duration-200">Terms &amp; Conditions</Link></li>
              <li><Link href="/how-i-choose" className="text-gray-300 hover:text-soft-blush transition-colors duration-200">Affiliate Disclosure</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2026 Capsule Chic Hub by Maria Personal Shopper. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm mt-4 md:mt-0">
            Made with ❤️ by Maria Personal Shopper
          </p>
        </div>
      </div>
    </footer>
  );
}
